import React, { useLayoutEffect } from "react";
import PropTypes from "prop-types";
import { bannerCloseIcon } from "../../images";
import { useNavigate } from "react-router-dom";
import styles from "./banner.module.css";
import AlertCopyBanner from "./alert-copy-banner";
import TimerPromoBanner from "./timer-promo-banner";

const Banner = (
  {
    showBanner, setShowBanner,
    // all banners
    message, dismissable, type, bannerColor, bannerUrl,
    // copy and timer banners             
    code,   
    // copy banners                                         
    icon,            
    // timer banners                   
    discount, title, btnLabel, btnType, dateAndTimeToExpire, expandedOnMobile   
  }
) => {
  /*
    This component implements multiple functionalities for different kinds of banner.
    Inputs
    dismissable - Takes input true/false to make banner dismissable or not. Default is true
    bannerColor - Takes input true/false to make banner yellow (true) or white (false). Default is true
    bannerUrl - Takes input of link within website that redirects when the banner is clicked. Default is null
    type  - Indicates the type of banner. Inputs are alert, copy and timer
    code - For copy Banners. It indicates the Discount Code to be copied to clipboard 
    icon - For copy Banners. Indicates the icon to be used for Copy Banner. Available icons - Canada, Christmas, Easter, StPatricks, Present, Valentines
    btnType - For timer Banners. Takes values copy/link and indicates instructions of the button.
    btnLabel - For Timer banner. Message on button.
    dateAndTimeToExpire - For Timer banner. Gives the time of Discount expiry for timer.
    expandedOnMobile - For Timer banner. For mobile only. 
    discount - For timer banner. Discount text on banner.
    title - For Timer banner. Discount title on banner. 
    message - common for all kinds of banner. For copy banner accepts html with tags in <span> indicating to be emboldened. 
  */
  // to describe banner type
  const alert = type === 'Alert'
  const copy = type === 'Copy'
  const timer = type === 'Timer'

  // Banner doesn't render if props are not correctly defined
  useLayoutEffect(() => {
    if (!alert && !copy && !timer) {
      setShowBanner(false)
    }
    // component won't show if it is not a copy, alert or timer banner
    if (timer && (!dateAndTimeToExpire || new Date(dateAndTimeToExpire).getTime() <= Date.now())) {
      setShowBanner(false);
    }
    // component won't show if timer banner has no expiry time or incorrect expiry time
  },
    [alert, copy, timer, setShowBanner]
  )

  // to handle banner escape
  const handleEscape = (e) => {
    e.stopPropagation()
    setShowBanner(false)
  }

  // to handle link
  const navigate = useNavigate()

  return (
    <>
      {showBanner &&
        <div
          className={
            [
              styles["header"],
              (alert || copy) && bannerUrl && styles["header_cursor"],
              bannerColor && styles["banner_color"],
              timer && styles["timer_header"],
              timer && expandedOnMobile && styles["expanded_header"]
            ].join(' ')
          }
          onClick={() => (alert || copy) && bannerUrl ? navigate(bannerUrl) : null}
        >
          {
            (alert || copy) &&
            < AlertCopyBanner
              escapeable={dismissable}
              alert={alert}
              copy={copy}
              couponCode={code}
              copyIconType={icon}
              message={message}
            />
          }
          {
            timer &&
            < TimerPromoBanner
              discount={`-${discount}%`}
              heading={title}
              btn_message={btnLabel}
              message={message}
              btn_type={btnType}
              couponCode={code}
              bannerUrl={bannerUrl}
              expiry_time={dateAndTimeToExpire}
              expanded={expandedOnMobile}
              setShowBanner={setShowBanner}
            />
          }
          {
            dismissable &&
            <div className={styles["top_btn"]} onClick={handleEscape}>
              <img src={bannerCloseIcon} alt="Close-icon" />
            </div>
          }
        </div >
      }
    </>
  );
};


Banner.defaultProps = {
  dismissable: true,
  bannerColor: true,
  bannerUrl: null,
  type: 'N/A',
  message: ''
}

Banner.propTypes = {
  dismissable: PropTypes.bool,
  bannerColor: PropTypes.bool,
  bannerUrl: PropTypes.string,
  type: PropTypes.string.isRequired,
  code: PropTypes.string,
  icon: PropTypes.string,
  showBanner: PropTypes.bool,
  discount: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  setShowBanner: PropTypes.func,
  dateAndTimeToExpire: PropTypes.string,
  expandedOnMobile: PropTypes.bool
};

export default Banner;
